import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom'

import GridElement from './GridElement'

import QueryParamsUtils from '../services/QueryParamsUtils.js'
import StringUtils from '../services/StringUtils.js'
import Player from '../services/player.js'
import MobileIdentifier from '../services/MobileIdentifier.js'

import '../../css/Grid.css';

class Grid extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = this.mapPropsToState(props);
    this.scrollStep = 700;
  }

  componentWillReceiveProps(newProps) {
    this.setState(this.mapPropsToState(newProps));
  }

  componentDidMount() {
    this.setState({});
  }

  mapPropsToState(props) {

    return {

      hasPeriods: props.hasPeriods || false,
      selectedPeriod: 'overall',

      total: props.total,

      elements: props.elements,
      title: props.title,
      type: props.type,
      max: props.max,
      playable: props.playable || false,

      mappable: props.mappable || false,
      treemappable: props.treemappable || false,
      mapContext: props.mapContext,
      mapSearchTerm: props.mapSearchTerm,
      mapType: props.mapType,
      mapTypeTerm: props.mapTypeTerm || '',
      mapParams: props.mapParams || {},

      carousel: props.carousel || false,

      showMore: false

    };

  }

  mapUrl() {
    return this.graphUrl('maps');
  }

  treemapUrl() {
    return this.graphUrl('treemaps');
  }


  graphUrl(type) {
    let context = this.state.mapContext;
    let searchTerm = this.state.mapSearchTerm;
    let mapType = this.state.mapType;
    let mapTypeTerm = this.state.mapTypeTerm;
    let mapParams = this.state.mapParams;

    if (this.state.hasPeriods) {
      mapParams.period = this.state.selectedPeriod
    }

    mapParams = JSON.parse(JSON.stringify(mapParams));

    if (!context || !searchTerm || !mapType) {
      if (mapParams.country) {
        context = 'country';
        searchTerm = mapParams.country;
        mapType = 'user_top_artists';
        mapTypeTerm = mapParams.userId;
      }

      if (mapParams.gender) {
        context = 'gender';
        searchTerm = mapParams.gender;
        mapType = 'user_top_artists';
        mapTypeTerm = mapParams.userId;
      }

      if (mapParams.timePeriod) {
        context = 'time_period';
        searchTerm = mapParams.timePeriod;
        mapType = 'user_top_artists';
        mapTypeTerm = mapParams.userId;
      }

      if (mapParams.tag) {
        context = 'tag';
        searchTerm = mapParams.tag;
        mapType = 'user_top_artists';
        mapTypeTerm = mapParams.userId;
      }
    }

    delete mapParams.page;

    let queryParams = QueryParamsUtils.toQueryParams(mapParams);

    let basePath = `/${type}/${context}/${searchTerm}/${mapType}`;
    let url;

    if (mapTypeTerm)
      url = `${basePath}/${mapTypeTerm}${queryParams}`;
    else
      url = `${basePath}${queryParams}`;

    return url;
  }

  gridElements() {
    let elements = this.state.hasPeriods ? this.state.elements[this.state.selectedPeriod] : this.state.elements;
    return elements || [];
  }

  visibleElements() {
    let max = this.state.max;
    let showMore = this.state.showMore;

    let visibleElements = this.gridElements();
    if (!showMore && max && !MobileIdentifier())
      visibleElements = visibleElements.slice(0, max);

    return visibleElements;
  }

  playElements() {

    let elements = this.gridElements()
    .map((element) => { 

      let newElement = {}; 

      Object.keys(element).forEach(function(key) {
       newElement[key] = element[key];
      }); 

      return newElement;

    });

    let params = {type: this.props.type, terms: elements};
    Player.searchTracks(params);
  }

  selectPeriod(period, evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.setState({selectedPeriod: period})
  }

  periods() {
    return ['overall', 'semesterly', 'monthly', 'weekly'];
  }

  renderPeriods() {

    return this.periods().map( (period) => {

      return (
        <label key={period} onClick={this.selectPeriod.bind(this, period)} className={`clickable ${period === this.state.selectedPeriod && 'active'}`}>
          {StringUtils.titleize(period)}
        </label>);

    });
  }

  scroll(direction, evt) {
    evt.preventDefault();
    evt.stopPropagation();

    if (direction === 'left') {
      this.refs.list.scrollLeft -= this.scrollStep;
    } else {
      this.refs.list.scrollLeft += this.scrollStep;
    } 
  }

  refresh() {
    this.setState({});
  }

  toggleShowMore() {
    this.setState({showMore: !this.state.showMore});
  }

  hasElements() {
    let visibleElements = this.visibleElements();
    let hasPeriods = this.state.hasPeriods;

    if (hasPeriods) {
      let count = 0;
      this.periods().forEach((period) => {
        count += (this.state.elements[period] && this.state.elements[period].length) || 0;
      });
      return count > 0;
    } else {
      return visibleElements.length > 0
    }

  }

  render() {

    let elements = this.gridElements();
    let title = this.state.title;
    let type = this.state.type;
    let max = this.state.max;
    let playable = this.state.playable || false;

    let total = this.state.total;
    
    let mappable = this.state.mappable || false;
    let treemappable = this.state.treemappable || false;

    let isMobile = MobileIdentifier();

    let showMore = this.state.showMore;

    let visibleElements = this.visibleElements();

    let hasElements = this.hasElements();

    let overflow = max && elements.length > max;

    if (!hasElements && total === undefined)
      return null;

    let gridClassName = 'grid';

    if (this.state.carousel) {
      gridClassName += ' carousel';
    }

    let showLeftScroll = false;
    let showRightScroll = false;

    if (this.refs.list) {
      showLeftScroll = this.refs.list.scrollLeft > 100;

      if (this.refs.list.children.length > 0) {
        let children = this.refs.list.children;
        let lastChild = children[children.length - 1];
        showRightScroll = lastChild.offsetLeft > window.innerWidth && this.refs.list.scrollLeft + window.innerWidth < lastChild.offsetLeft + lastChild.offsetWidth;
      }

    }

    return (
      <div className={gridClassName}>

        <div className="header">
          { title && <h2>{title} { this.props.total ? `(${total})` : '' } </h2> } 
          { elements.length > 0 && playable && <i title="Play" onClick={this.playElements.bind(this)} className="clickable play icon-inner-play"></i> }
          { elements.length > 0 && mappable && <Link to={this.mapUrl()}><i title="Go to similarity map" className="clickable map icon-map"></i></Link> }
          { elements.length > 0 && treemappable && <Link to={this.treemapUrl()}><i title="Go to treemap" className="clickable map icon-tree"></i></Link> }

        </div>

        {this.state.hasPeriods && (<div className="periods">
          {this.renderPeriods()}
        </div>)}

        {hasElements && <ul ref="list" onScroll={this.refresh.bind(this)}>
          { this.state.carousel && !isMobile && <div className="arrows">
            <div className="left carousel-container clickable" onClick={this.scroll.bind(this, 'left')}>{ showLeftScroll && <i title="Scroll left" className="clickable left carousel-arrow icon-chevron-left-1"></i> }</div>
            <div className="right carousel-container clickable" onClick={this.scroll.bind(this, 'right')}>{ showRightScroll && <i title="Scroll right" className="clickable right carousel-arrow icon-chevron-right-1"></i> }</div>
          </div> }
          {visibleElements.map((item, index) => {
            return (
              <GridElement key={`${item[type]}-${index}`} type={type} element={item}/>
            );
          })}
        </ul>}

        { overflow && <div className="showMore">
          { !isMobile && overflow && !showMore && <label onClick={this.toggleShowMore.bind(this)} className="clickable">Show more</label>}
          { !isMobile && overflow && showMore && <label onClick={this.toggleShowMore.bind(this)} className="clickable">Hide</label>}
        </div> }
        
      </div>
    ); 

  }
}

export default withRouter(Grid);



// WEBPACK FOOTER //
// ./src/js/components/Grid.jsx